module.exports = __webpack_public_path__ + "static/media/ctc-fs-new-lumbar@2x.73f7d9d8.png";